export const SYLLABUS = [
  {
    moduleTitle: "A1 | Elementary (The Basics)",
    description: "Immediate needs, introductions, and simple daily interactions.",
    subLevels: [
      {
        level: "Livello 1: Primi Passi",
        focus: "Your Survival Kit",
        goal: "I can read Italian with the right pronounciation and rythm, introduce myself, and ask for help when I'm stuck. I’m also ready to handle numbers, the Euro, and the calendar.",
        topics: [
          "Alfabeto e Fonetica",
          "Presentazioni e Saluti",
          "Scusa? Non capisco",
          "La frase semplice",
          "Nomi (Genere e Numero)",
          "I Numeri e l'Euro",
          "Calendario e Stagioni"
        ]
      },
      {
        level: "Livello 2: In città",
        focus: "Exploring the Streets",
        goal: "I can find my way around an Italian city, ask for directions, and describe the people and places I see in full color.",
        topics: [
          "La città e Le indicazioni stradali",
          "Articoli Indeterminativi e Buono",
          "Presente di AVERE",
          "Aggettivi e Colori",
          "Presente di ESSERE",
          "Descrizione Fisica e la Personalità",
          "Nazionalità",
          "Molto",
          "C’è / Ci sono - Come è / Come sono"
        ]
      },
      {
        level: "Livello 3: Famiglia",
        focus: "Your Inner Circle",
        goal: "I can talk about my family, tell the time, and use the core \"power verbs\" that keep a conversation moving.",
        topics: [
          "Articoli Determinativi e Bello",
          "La Famiglia",
          "Presente dei verbi in -ARE",
          "L'ora",
          "Dare, Stare, Andare, Fare",
          "Aggettivi possessivi"
        ]
      },
      {
        level: "Livello 4: Tempo Libero",
        focus: "Hobbies and Habits",
        goal: "I can chat about the weather, my hobbies, and finally express what I want, need, and must do.",
        topics: [
          "Questo e Quello",
          "Il Meteo",
          "Il tempo libero",
          "Presente dei verbi in -ERE e -IRE",
          "Verbi Modali (DOVERE, POTERE, VOLERE)",
          "DIRE, USCIRE, VENIRE"
        ]
      }
    ]
  },
  {
    moduleTitle: "A2 | Pre-Intermediate (Past & Daily Life)",
    description: "Describing the past, personal experiences, and more complex social situations.",
    subLevels: [
      {
        level: "Livello 5: Ieri e Oggi",
        focus: "The Big Leap into the Past",
        goal: "I can order my breakfast like a local and share exactly what I did yesterday. This is where my storytelling truly begins.",
        topics: [
          "Pronomi di Oggetto Diretto",
          "Le bevande e la colazione",
          "Il verbo Piacere",
          "Preposizioni Semplici",
          "Preposizioni articolate",
          "Passato Prossimo con Essere",
          "Passato Prossimo con Avere",
          "Verbi Modali al Passato Prossimo",
        ]
      },
      {
        level: "Livello 6: Sapori e Ricordi",
        focus: "Dining & Connection",
        goal: "I can navigate a restaurant menu with ease and start describing past events with more detail and flow.",
        topics: [
          "Conoscere vs Sapere",
          "Il ristorante e il cibo",
          "I Pronomi Indiretti",
          "Accordo del Participio Passato nel Passato Prossimo",
          "L’Imperfetto"
        ]
      },
      {
        level: "Livello 7: La Mia Routine",
        focus: "Life & Style",
        goal: "I can describe my childhood memories, talk about my daily routine, and even go shopping for clothes with confidence.",
        topics: [
          "Imperfetto vs Passato Prossimo",
          "Il Trapassato Prossimo",
          "Il Gerundio",
          "Gli Interrogativi",
          "Abbigliamento e Shopping",
          "I verbi riflessivi e la routine giornaliera",
          "Costruzione reciproca"
        ]
      },
      {
        level: "Livello 8: La mia Salute",
        focus: "Health",
        goal: "I can explain how I feel to a doctor and use those \"little words\" that make me sound less like a student and more like a native.",
        topics: [
          "Presente + Da + Espressioni di tempo",
          "Presente + Per + Espressioni di tempo",
          "Avverbi",
          "I suffissi",
          "Le parti del corpo / Dal dottore",
          "I pronomi tonici"
        ]
      },
      {
        level: "Casa e Vacanze",
        focus: "Comparison & Comfort",
        goal: "I can describe my dream home and compare my favorite travel spots to say what’s \"better\" or \"the best.\"",
        topics: [
          "I comparativi",
          "I superlativi relativi",
          "I comparativi e i superlativi irregolari",
          "La casa",
          "Le vacanze"
        ]
      }
    ]
  },
  {
    moduleTitle: "B1 | Intermediate (Independence)",
    description: "Expressing future plans, giving advice, storytelling, and managing more abstract topics like art or the environment.",
    subLevels: [
      {
        level: "Livello 10: Il Futuro",
        focus: "Plans & Perspectives",
        goal: "I can talk about my future plans, navigate local markets, and master the complex pronouns that make my voice feel natural.",
        topics: [
          "Il Futuro Semplice e i suoi usi speciali",
          "Il Si Impersonale",
          "La formazione dei nomi femminili",
          "I negozi e i mercati",
          "Usi di NE e CI",
          "Pronomi Doppi"
        ]
      },
      {
        level: "Livello 11: Consigli e Viaggi",
        focus: "Influence & Adventure",
        goal: "I can give advice and helpful instructions, talk about the environment, and plan my next big trip through Italy.",
        topics: [
          "L'Imperativo - Tu, Noi, Voi",
          "Gli aggettivi indefiniti",
          "I pronomi indefiniti",
          "I negativi",
          "L'Imperativo - Lei, Loro",
          "Dove andare in viaggio",
          "L'ambiente",
          "Gli animali"
        ]
      },
      {
        level: "Livello 12: Desideri",
        focus: "The Art of Polite Wishes",
        goal: "I can express my dreams and \"what if\" scenarios politely, plus talk about movies and the world of entertainment.",
        topics: [
          "Il Condizionale Presente",
          "Dovere, Potere e Volere al Condizionale",
          "Il Condizionale Passato",
          "I pronomi Possessivi",
          "Lo Spettacolo"
        ]
      },
      {
        level: "Livello 13: Cultura",
        focus: "Heritage & History",
        goal: "I can dive into Italian art and literature while connecting complex ideas together using the \"historical\" past.",
        topics: [
          "I pronomi relativi",
          "Chi",
          "Costruzioni con l'Infinito",
          "Nomi e Aggettivi in -A",
          "Arte, Letteratura e Archeologia",
          "Il Passato Remoto"
        ]
      }
    ]
  },
  {
    moduleTitle: "B2 | Upper Intermediate (Opinions & Nuance)",
    description: "Expressing doubt, subjective opinions, and debating complex social issues with correct grammatical correlation.",
    subLevels: [
      {
        level: "Livello 14: L'Arte del Dubbio",
        focus: "Opinions & Feelings",
        goal: "I can express my hopes, fears, and personal opinions with sophistication. This is where you find your true Italian voice.",
        topics: [
          "Congiuntivo Presente",
          "Verbi e espressioni che richiedono il Congiuntivo",
          "Altri usi del Congiuntivo",
          "Congiuntivo o Infinito?",
          "L'Imperfetto del Congiuntivo",
          "Il Trapassato del Congiuntivo",
          "Correlazione dei tempi nel Congiuntivo"
        ]
      },
      {
        level: "Livello 15: Padronanza Totale",
        focus: "Real World Fluency",
        goal: "I can debate politics, discuss work, and navigate the nuances of Italian society with total independence.",
        topics: [
          "Il periodo ipotetico",
          "I numeri ordinali",
          "Volerci e Metterci",
          "La Politica",
          "Il Lavoro",
          "La società Multiculturale"
        ]
      }
    ]
  },
  {
    moduleTitle: "C1 | Advanced (Precision & Strategy)",
    description: "Understanding implicit meanings and using the language flexibly for social, academic, and professional purposes.",
    subLevels: [
      {
        level: "Livello 16: Professionalità e Sfumature",
        focus: "Professional Mastery",
        goal: "I can lead professional meetings, understand complex technical texts, and use subtle grammatical shifts to change the tone of my message.",
        topics: [
          "Il Passivo (Andare, Venire, Si Passivante)",
          "Discorso Indiretto Complesso",
          "Congiunzioni Testuali Avanzate",
          "Frasi Scisse (Enfasi)",
          "Usi di 'Anzi', 'Ossia', 'Ovvero'",
          "Il gergo burocratico e formale",
          "L'italiano nel mondo del lavoro"
        ]
      }
    ]
  },
  {
    moduleTitle: "C2 | Mastery (Total Fluency)",
    description: "Effortless precision. Understanding virtually everything heard or read and expressing nuances of meaning spontaneously.",
    subLevels: [
      {
        level: "Livello 17: La Voce del Madrelingua",
        focus: "Cultural & Literary Depth",
        goal: "I can appreciate Italian literature, understand regional dialects, and express irony or sarcasm with the same precision as a native speaker.",
        topics: [
          "Analisi dei testi letterari",
          "Figure retoriche e metafore",
          "Sfumature regionali e dialettismi",
          "L'italiano arcaico vs Moderno",
          "Strategie di persuasione e retorica",
          "Ironia, Sarcasmo e Sottintesi culturali",
          "Dibattito su temi filosofici ed etici"
        ]
      }
    ]
  }
];

// ─── Paste this into StudentDashboard.jsx replacing the existing TOPIC_SYLLABUS_MAP ───

export const TOPIC_SYLLABUS_MAP = {
  // A1 Livello 1: Primi Passi
  presentazioni:   { module: 'A1', level: 'Livello 1: Primi Passi' },
  non_capisco:     { module: 'A1', level: 'Livello 1: Primi Passi' },
  numeri:          { module: 'A1', level: 'Livello 1: Primi Passi' },
  calendario:          { module: 'A1', level: 'Livello 1: Primi Passi' },
  espressioni_tempo:   { module: 'A1', level: 'Livello 1: Primi Passi' },
  giorni_speciali: { module: 'A1', level: 'Livello 1: Primi Passi' },

  // A1 Livello 2: In Città
  'città':           { module: 'A1', level: 'Livello 2: In Città' },
  trasporti:         { module: 'A1', level: 'Livello 2: In Città' },
  augurare:          { module: 'A1', level: 'Livello 2: In Città' },
  avere:             { module: 'A1', level: 'Livello 2: In Città' },
  aggettivi_fisici:  {module: 'A1', level: 'Livello 2: In Città' },
  capelli_occhi:     {module: 'A1', level: 'Livello 2: In Città' },
  aggettivi_carattere: { module: 'A1', level: 'Livello 2: In Città' },
  colori:            { module: 'A1', level: 'Livello 2: In Città' },
  nazionalita:       { module: 'A1', level: 'Livello 2: In Città' },

  // A1 Livello 3: Famiglia
  famiglia:        { module: 'A1', level: 'Livello 3: Famiglia' },

  // A1 Livello 4: Tempo Libero
  meteo:           { module: 'A1', level: 'Livello 4: Tempo Libero' },
  passatempi:      { module: 'A1', level: 'Livello 4: Tempo Libero' },
  sport:           { module: 'A1', level: 'Livello 4: Tempo Libero' },

  // A2 Livello 5: Ieri e Oggi
  colazione_bar:   { module: 'A2', level: 'Livello 5: Ieri e Oggi' },
  professioni:     { module: 'A2', level: 'Livello 5: Ieri e Oggi' },

  // A2 Livello 6: Sapori e Ricordi
  ristorante:        { module: 'A2', level: 'Livello 6: Sapori e Ricordi' },
  'il cibo':         { module: 'A2', level: 'Livello 6: Sapori e Ricordi' },  // keep for old data
  pasti:             { module: 'A2', level: 'Livello 6: Sapori e Ricordi' },
  primi_piatti:      { module: 'A2', level: 'Livello 6: Sapori e Ricordi' },
  secondi_contorni:  { module: 'A2', level: 'Livello 6: Sapori e Ricordi' },
  supermercato:      { module: 'A2', level: 'Livello 6: Sapori e Ricordi' },
  frutta:            { module: 'A2', level: 'Livello 6: Sapori e Ricordi' },
  verdura:           { module: 'A2', level: 'Livello 6: Sapori e Ricordi' },

  // A2 Livello 7: La Mia Routine
  vestiti:           { module: 'A2', level: 'Livello 7: La Mia Routine' },
  accessori:         { module: 'A2', level: 'Livello 7: La Mia Routine' },

  // A2 Livello 8: La Mia Salute
  corpo:           { module: 'A2', level: 'Livello 8: La Mia Salute' },
  dottore:         { module: 'A2', level: 'Livello 8: La Mia Salute' },

  // A2 Casa e Vacanze
  casa_generale:   { module: 'A2', level: 'Casa e Vacanze' },
  bagno:           { module: 'A2', level: 'Casa e Vacanze' },
  camera_da_letto: { module: 'A2', level: 'Casa e Vacanze' },
  cucina_stanza:   { module: 'A2', level: 'Casa e Vacanze' },
  soggiorno:       { module: 'A2', level: 'Casa e Vacanze' },
  ripostiglio:     { module: 'A2', level: 'Casa e Vacanze' },
  giardino:        { module: 'A2', level: 'Casa e Vacanze' },
  vacanze:         { module: 'A2', level: 'Casa e Vacanze' },

  // B1 Livello 10: Il Futuro
  mercato:         { module: 'B1', level: 'Livello 10: Il Futuro' },
  aeroporto:       { module: 'B1', level: 'Livello 10: Il Futuro' },

  // B1 Livello 11: Consigli e Viaggi / L'Ambiente
  animali_selvatici:  { module: 'B1', level: "Livello 11: Consigli e Viaggi" },
  animali_domestici:  { module: 'B1', level: "Livello 11: Consigli e Viaggi" },
  campagna:           { module: 'B1', level: "Livello 11: Consigli e Viaggi" },
  fattoria:           { module: 'B1', level: "Livello 11: Consigli e Viaggi" },
  mare:               { module: 'B1', level: "Livello 11: Consigli e Viaggi" },
  parco:              { module: 'B1', level: "Livello 11: Consigli e Viaggi" },

  // Extra Vocabulary — officina, scuola, giocattoli, festa, contrari, forme, lunapark, circo
  // (no entry = falls through to Extra Vocabulary automatically)
};

// ─── Also update SYLLABUS_SECTIONS to add B1 ─────────────────────────────────

export const SYLLABUS_SECTIONS = [
  {
    module: 'A1',
    moduleLabel: 'A1 · Elementary',
    color: '#606C38',
    levels: [
      { level: 'Livello 1: Primi Passi',   focus: 'Your Survival Kit' },
      { level: 'Livello 2: In Città',      focus: 'Exploring the Streets' },
      { level: 'Livello 3: Famiglia',      focus: 'Your Inner Circle' },
      { level: 'Livello 4: Tempo Libero',  focus: 'Hobbies & Habits' },
    ],
  },
  {
    module: 'A2',
    moduleLabel: 'A2 · Pre-Intermediate',
    color: '#BC6C25',
    levels: [
      { level: 'Livello 5: Ieri e Oggi',      focus: 'The Big Leap into the Past' },
      { level: 'Livello 6: Sapori e Ricordi', focus: 'Dining & Connection' },
      { level: 'Livello 7: La Mia Routine',   focus: 'Life & Style' },
      { level: 'Livello 8: La Mia Salute',    focus: 'Health' },
      { level: 'Casa e Vacanze',              focus: 'Comparison & Comfort' },
    ],
  },
{
    module: 'B1',
    moduleLabel: 'B1 · Intermediate',
    color: '#4A7C59',
    levels: [
      { level: 'Livello 10: Il Futuro',         focus: 'Plans & Perspectives' },
      { level: 'Livello 11: Consigli e Viaggi', focus: 'Influence & Adventure' },
      { level: 'Livello 12: Desideri',          focus: 'The Art of Polite Wishes' },
      { level: 'Livello 13: Cultura',           focus: 'Heritage & History' },
    ],
  },
  {
    module: 'B2',
    moduleLabel: 'B2 · Upper Intermediate',
    color: '#5C4A8A',
    levels: [
      { level: "Livello 14: L'Arte del Dubbio", focus: 'Opinions & Feelings' },
      { level: 'Livello 15: Padronanza Totale', focus: 'Real World Fluency' },
    ],
  },
  {
    module: 'C1',
    moduleLabel: 'C1 · Advanced',
    color: '#2C5F6E',
    levels: [
      { level: 'Livello 16: Professionalità e Sfumature', focus: 'Professional Mastery' },
    ],
  },
  {
    module: 'C2',
    moduleLabel: 'C2 · Mastery',
    color: '#1A1A2E',
    levels: [
      { level: 'La Voce del Madrelingua', focus: 'Cultural & Literary Depth' },
    ],
  },
];